module.exports = __webpack_public_path__ + "static/media/for-startup-programs-first.7baaabdb.jpg";